import { z } from 'zod';

export const authorizeCallbackResDto = z.object({
  code: z.string(),
});
export type AuthorizeCallbackResDto = z.infer<typeof authorizeCallbackResDto>;
